import {
    Component,
    OnInit,
    Input,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SweetAlertResult } from "sweetalert2";

import { SharedService } from "@services/shared.service";
import { ApiTransactionService } from "@services/api-transaction.service";
import { ApiAccountService } from "@services/api-account.service";

import { CustomerModel } from "@models/CustomerModel";
import { CustomerCardModel } from "@models/CardModel";
import {
    BuyerType,
    TransactionModel,
    NewTransactionProductModel,
    ProductOrderModel,
} from "@models/TransactionModel";
import { CardPaymentModel } from "@models/RegisterModel";
import { CardFormComponent } from '@components/card-form/card-form.component';
import {
    PayType,
    CategoryType,
    ProductTaxType,
    CurrencyType,
    Country,
} from "@models/Enums";

import { ModalFormBase } from "@shared/modal-base.component";

import { envVariables } from "@shared/mock-data";

import { ProductModel } from "@models/ProductModel";
import { Constants } from "@shared/shared.constants";

@Component({
    selector: "app-purchase-product-modal",
    templateUrl: "./purchase-product-modal.component.html",
    styleUrls: ["./purchase-product-modal.component.scss"],
})
export class PurchaseProductModalComponent
    extends ModalFormBase<NewTransactionProductModel>
    implements OnInit
{
    @Input() user: CustomerModel;
    @Input() product: ProductModel;
    @Input() productOrigin: ProductModel;

    @ViewChild("purchaseModal", { static: true }) modal: TemplateRef<any>;

    model: NewTransactionProductModel;

    // form


    methods: CustomerCardModel[] = [];
    currentMethod: CustomerCardModel;

    selectedMethod = "";

    // País de la sesión: define la pasarela con la que se agrega la tarjeta
    country: Country = Country.CR;

    newCard: CardPaymentModel;
    requireInvoice = false;

    //accordion flags
    paymentMethodAccordion = false;
    pointsAccordion = false;

    assignedSuccess = false;

    constructor(
        private router: Router,
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiAccountService: ApiAccountService,
        private apiTransactionService: ApiTransactionService
    ) {
        super(modalService);
    }

    ngOnInit(): void {

        this.country = this.apiTransactionService.getSession()?.user?.country ?? Country.CR;

        this._getPaymentMethods(false);
    }

    onShowGetPoints() {
        this.onClose();        
        this.sharedService.setShowGetPointsModal(true);
    }

    onOpen() {
        if (!this.user) {
            return this.sharedService.SwalCustom.fire({
                title: "Iniciar sesión",
                text: "Para comprar el Givi POPs debe iniciar sesión.",
                showCancelButton: true,

                cancelButtonText: "Cancelar",
                confirmButtonText: "Iniciar sesión",

                allowOutsideClick: false,

                customClass: {
                    confirmButton: "btn btn-modal-main",
                    cancelButton: "btn btn-modal-second",
                },
                buttonsStyling: false,
            }).then((result: SweetAlertResult) => {
                if (result && result.value) {
                    this.router.navigate(["login"]);
                }
            });
        }

        setTimeout(() => window.scrollTo({ top: 0 }), 100);

        this._getPaymentMethods();

        this.onNext();

        super.open(this.modal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-content-full",
        });
    }

    onClose() {
        super.close();
    }

    // cuando se selecciona el product y va al resumen de pago
    onNext() {
        // Imagen seleccionada
        let productImageId = this.product.images[0].id;

        // Si el producto es Givi Gift siempre seleccionar la imagen de portada
        if (
            this.productOrigin.categories.some(
                (x) => x.type == CategoryType.GiviGifts
            )
        ) {
            // Se reset la imagen seleccionada
            this.product.images[0] = this.productOrigin.images[0];
            productImageId = this.product.images[0].id;
        }

        this.model = new NewTransactionProductModel({
            vendorId: this.product.vendorId,
            buyerType: BuyerType.Customer,
            customerId: this.user.id,

            subTotal: this.product.priceTotal,
            taxTotal: 0, // No tiene IVA
            total: this.product.priceTotal,

            points: 0,
            pointsValue: envVariables[Constants.ENV_POINTS_VALUE_KEY] ?? 1,

            products: [
                new ProductOrderModel({
                    productId: this.product.id,
                    sku: this.product.sku,
                    productName: this.product.name,
                    productImageId: productImageId,

                    quantity: this.product.quantitySelected,
                    points: this.product.points,

                    price: this.product.allowDiscount
                        ? this.product.priceWithDiscount
                        : this.product.price,
                    tax: 0, // No tiene IVA
                    taxType: ProductTaxType.Exempt,
                    taxPercent: 0,
                    // totalPrice: product.price
                    currencyType: CurrencyType.CRC,
                    // Precio proveedor
                    vendorPrice: this.product.vendorPrice,
                    vendorPriceWithTax: this.product.vendorPriceWithTax,
                    // Precio a Givi
                    vendorDiscountType: this.product.vendorDiscountType,
                    vendorPriceWithDiscount:
                        this.product.vendorPriceWithDiscount,

                    shippingProviderId: this.product.shippingProviderId,
                }),
            ],
        });

        if (this.product.communityId > 0) this.model.communityId = this.product.communityId;

        this._formInit();
    }

    onSelectMethod(card: CustomerCardModel, toggleAccordion: number) {
        this.currentMethod = card;
        this.onToggleAccordion(toggleAccordion);
        //modal.dismiss();
    }

    @ViewChild(CardFormComponent) cardFormComponent: CardFormComponent;

    // La tarjeta la arma app-card-form y llega por (cardChange). null = incompleta.
    onCardChange(card: CardPaymentModel) {

        this.newCard = card;
    }

    onSaveCard(modal: any): void {

        if (!this.newCard) return;

        this.newCard.companyId = this.user.id;

        if (this.cardFormComponent?.isAmexCVC) {
            const errMsg =
                "No se aceptan tarjetas American Express. Por favor revisá la información y volvé a intentarlo.";
            this.sharedService.showErrorAlert(null, errMsg);
        } else {
            this.sharedService.setLoading(true);

            this.apiAccountService.addCard(this.newCard).then(
                (data: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    this._getPaymentMethods();

                    this.sharedService
                        .showSuccessAlert(
                            null,
                            `La tarjeta fue agregada correctamente`
                        )
                        .then((_) => modal.dismiss());
                },
                (err: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    const errMsg =
                        "No se pudo agregar la tarjeta. Por favor revisá la información y volvé a intentarlo.";
                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    onCreateCard(paymentMethodModal: any) {
        this.newCard = null;

        this.modalService.open(paymentMethodModal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-full",
        });
    }

    onOpenMethods(paymentMethodModal: any) {

        this.modalService.open(paymentMethodModal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-full",
        });
    }

    onCloseSucess(){
        this.assignedSuccess = false;
        this.sharedService.setProductForModal(null);
    }

    onPay() {

        if (this.model && this.currentMethod) {
            this.model.cardToken = this.currentMethod.token;

            if (this.model.points > 0) {
                this.model.payType = PayType.CardPoints;
            } else {
                this.model.payType = PayType.Card;
            }

            this.sharedService.setLoading(true);

            this.apiTransactionService.payOrderProduct(this.model).then(
                (transaction: any) => {
                    this.apiTransactionService.loadAccount();

                    this.sharedService.setLoading(false);

                    this.assignedSuccess = true;
                },
                (err: any) => {
                    this.sharedService.setLoading(false);

                    let errMsg = "";

                    if (typeof err.error?.Message == "string" && err.error?.Message.length) {
                        errMsg = err.error?.Message;
                    } else {
                        errMsg =
                            "No se pudo realizar la compra. Por favor revisá la información y volvé a intentarlo.";
                    }

                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    // Form

    onToggleAccordion(accordionType) {
        if (accordionType == 2) {
            this.paymentMethodAccordion = !this.paymentMethodAccordion;
        } else {
            if (this.pointsAccordion) {
                /*  this.model.points = 0;
                this.model.total = this.model.subTotal; */
            }
            this.pointsAccordion = !this.pointsAccordion;
        }
    }

    onReceivePointsSelected(receivedPoints: number) {
        //total points
        this.model.points = receivedPoints;
        // discount in colones
        this.model.pointsDiscount = receivedPoints * this.model.pointsValue;
        //total with the discount
        this.model.total = this.model.subTotal - this.model.pointsDiscount;
    }

    private _formInit(): void {
        this.requireInvoice = false;

        // Reset for hide form errors
        this.touched = true;
    }

    // End Form

    private _getPaymentMethods(showSpinner = true) {
        // No hacer la llamada si no esta logueado
        if (!this.user) return;

        if (showSpinner) this.sharedService.setLoading(true);

        return this.apiAccountService.getAllCards(this.user.id).then(
            (cards: CustomerCardModel[]) => {
                this.currentMethod = cards.find((x) => x.isCurrent);
                if (this.currentMethod) {
                    this.selectedMethod = this.currentMethod.token;
                }

                this.methods = cards; // update the source

                if (showSpinner) this.sharedService.setLoading(false);
            },
            (err: any) => {
                if (showSpinner) this.sharedService.setLoading(false);
            }
        );
    }
}
